"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = require("@seedlang/constants");
var _lodash = _interopRequireDefault(require("lodash"));
var _date_decorator = _interopRequireDefault(require("./date_decorator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // reminder to not import AppUI to avoid circular dependencies
var SpacedRepetition = /*#__PURE__*/function () {
  function SpacedRepetition() {
    _classCallCheck(this, SpacedRepetition);
  }
  return _createClass(SpacedRepetition, [{
    key: "onResetSpacedRepetition",
    value: function onResetSpacedRepetition(obj) {
      obj.set('easinessFactor', 2.5);
      obj.set('consecutiveGoodScores', 0);
      obj.set('repetitionInterval', null);
      obj.set('reviewAfter', new _date_decorator["default"](new Date()));
      obj.set('hadPositiveScore', false);
      obj.set('viewsCount', 0);
    }
  }, {
    key: "processRecallResult",
    value: function processRecallResult(qualityOfRecall, obj, update, forceReviewAfterDue) {
      // https://apps.ankiweb.net/docs/manual.html#what-spaced-repetition-algorithm-does-anki-use
      var updatedConsecutiveGoodScores;
      var updatedRepetitionInterval;
      var updatedEasinessFactor = this.calculateEasinessFactor(obj.easinessFactor, qualityOfRecall);
      if (update) {
        obj.set('easinessFactor', updatedEasinessFactor);
      }
      if (qualityOfRecall === _constants.Constants.BAD_SCORE) {
        updatedRepetitionInterval = 0;
        updatedConsecutiveGoodScores = 0;
      }
      if (obj.viewsCount === 0 || obj.consecutiveGoodScores === 0) {
        return qualityOfRecall === _constants.Constants.GOOD_SCORE ? 1 : 4;
      }
      updatedConsecutiveGoodScores = obj.consecutiveGoodScores + 1;
      if (updatedConsecutiveGoodScores === 1) {
        updatedRepetitionInterval = 1;
      } else if (!forceReviewAfterDue && new Date() < obj.reviewAfter.dateObj) {
        if (obj.lastScore === qualityOfRecall) {
          updatedRepetitionInterval = obj.repetitionInterval;
        } else if (obj.lastScore === 3 && qualityOfRecall === 5) {
          updatedRepetitionInterval = obj.repetitionInterval * 2;
        } else {
          updatedRepetitionInterval = obj.repetitionInterval / 2;
        }
      } else {
        updatedRepetitionInterval = obj.repetitionInterval * updatedEasinessFactor;
        if (qualityOfRecall === _constants.Constants.EASY_SCORE) {
          updatedRepetitionInterval *= 1.5;
        } else {
          updatedRepetitionInterval *= 0.9;
        }
        if (obj.repetitionInterval && updatedRepetitionInterval < obj.repetitionInterval + 1) {
          updatedRepetitionInterval = obj.repetitionInterval + 1;
        }
        var fuzz = (0, _lodash["default"])(0.9, 1.1);
        updatedRepetitionInterval *= fuzz;
      }
      var days = Math.round(updatedRepetitionInterval * 10) / 10;
      return days < 1 ? 1 : days;
    }
  }, {
    key: "calculateEasinessFactor",
    value: function calculateEasinessFactor(easinessFactor, qualityOfRecall) {
      // I don't want the lowest score to not affect easiness factor
      if (easinessFactor === 0) {
        easinessFactor = 1;
      }
      var result = easinessFactor - 0.8 + 0.28 * qualityOfRecall - 0.02 * qualityOfRecall * qualityOfRecall;
      return result < 1.3 ? 1.3 : Math.round(result * 10) / 10;
    }
  }]);
}();
var _default = exports["default"] = new SpacedRepetition();